import React, { useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Close, Send } from '@mui/icons-material';
import * as actions from "../../store/actions";
import Upload from '../../UI/Upload';
import FileList from '../../UI/FileList';
import {
    InputFilesLabel,
    FormInputView,
    ProfileForm,
    ProfileFormName,
    ProfileFormPicture
} from './styles';
import {
	Avatar,
    Button,
    IconButton,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
    FormControl,
    TextField,
} from "@mui/material";
import { i18n } from '../../translate/i18n';
import { withStyles, makeStyles } from '@mui/styles';

const styles = {
	modalStyle: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	avatar: {
		width: 60,
		height: 60,
		fontSize: 13
	},
	sendButton: {
		backgroundColor: 'green',
		color: '#fff',
		margin: '0.75rem 1rem'
	},
	closeButton: {
		position: 'absolute',
		fontSize: '1.1rem',
		top: 10,
		right: 10,
	},
	uploadFileBox: {
		width: '80%',
	},
};

const useStyles = makeStyles(() => ({
	paper: { minWidth: "50vw" },
	root: {
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "grey"
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "grey"
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "grey",
			borderWidth: '1px'
    },
  }
}));


const DialogTitleCustom = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;

  return (
      <DialogTitle className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={onClose}
              size="large">
            <Close />
          </IconButton>
        ) : null}
      </DialogTitle>
  );
});

const NewActionPostInput = ({ auth, closeModal }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const actionService = useSelector(state => state.actions.action);
    const [inputType, setInputType] = useState('text');

    const [userName, setUserName] = useState(null);
    // const [userPicture, setUserPicture] = useState(null);
    const [messageContent, setMessageContent] = useState("")
    const [messageContentError, setMessageContentError] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([]);

    const addMessageTimelineAction = (index, body) => dispatch(actions.addMessageTimelineAction(index, body));

    const handleSave = () => {
        if (inputType === 'text') {
            if (messageContent !== '') {
                closeModal();
                const body = {
                    message: messageContent
                }
                addMessageTimelineAction(actionService._id, body)
                    .then(result => {
                        if (result === 'success') {
                            setMessageContent("");
                        }
                    })
            } else {
                setMessageContentError(true);
            }
        }
    }

    const fetchLoggedUser = async () => {
        setUserName(auth.name);
        // setUserPicture('');
    };

    useEffect(() => {
        fetchLoggedUser();
    }, []);

    return (
        <Dialog
          classes={{ paper: classes.paper}}
          style={styles.modalStyle}
          maxWidth="lg"
          fullWidth
          scroll='body'
          open
          onClose={closeModal}
        >
            <DialogTitleCustom id="customized-dialog-title-post-input" onClose={closeModal}>
                <div style={{ color: 'black', fontWeight: 'bold' }}>{i18n.t('newActionHeader.label')}</div>
            </DialogTitleCustom>
            <DialogContent dividers>
                <ProfileForm>
                    <ProfileFormPicture>
                        <Avatar style={styles.avatar}>{' '}</Avatar>
                    </ProfileFormPicture>
                    <ProfileFormName>{userName}</ProfileFormName>
                </ProfileForm>
                {
                    inputType === 'text' &&
                    <FormControl variant="standard" fullWidth>
                        <TextField
                            className={classes.root}
                            value={messageContent}
                            margin='normal'
                            error={messageContentError}
                            placeholder={i18n.t('inputViewNew.placeholder')}
                            onChange={(e) => { setMessageContent(e.target.value); setMessageContentError(false); }}
                            autoFocus
                            multiline
                            rows={4}
                            variant='outlined'
                            helperText={i18n.t('inputErrorLabelNew.label')}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </FormControl>
                    // <FormInputView>
                    // <InputView placeholder={} error={} value={} onChange={} />
                    // {messageContentError && <InputErrorLabel>{}</InputErrorLabel>}
                    // </FormInputView>
                }
                {   
                    inputType === 'file' &&
                    <FormInputView>
                        <InputFilesLabel>{i18n.t('inputFilesLabelNew.text')}</InputFilesLabel>
                        <Upload onUpload={handleSave} style={styles.uploadFileBox} />
                        {!!uploadedFiles.length && (
                        <FileList files={uploadedFiles} onDelete={undefined} />
                        )}                            
                    </FormInputView>
                }                    
            </DialogContent>
                    {/* <InputIconGroup>
                        <InputIcon onClick={() => setInputType('file')}>
                            <CameraAltOutlined style={{ color: '#87b488' }} />
                            <InputIconLabel>Foto/Vídeo</InputIconLabel>
                        </InputIcon>
                        <InputIcon>
                            <LinkOffOutlined style={{ color: '#87b488' }} />
                            <InputIconLabel>Link</InputIconLabel>
                        </InputIcon>
                        <InputIcon onClick={() => setInputType('file')}>
                            <AttachmentOutlined style={{ color: '#87b488' }} />
                            <InputIconLabel>Anexar arquivo</InputIconLabel>
                        </InputIcon>
                    </InputIconGroup> */}
            <DialogActions>
                <Button startIcon={<Send />} variant="contained" onClick={handleSave} style={styles.sendButton}>
                    {i18n.t('btnNewActionPost.text')}
                </Button>
            </DialogActions>    
        </Dialog>
    );
};

export default connect((state) => ({ auth: state.auth }))(NewActionPostInput);
